<template>
  <div>
    <div v-if="loaded" class="flex flex-col md:flex-row justify-between">
      <div class="flex-1" >
        <div v-if="event.entry_settings.has_member_pricing" class="mb-4 bg-gray-200 p-2 md:p-4 rounded">
          <h3 class="text-xl mb-2">{{event.entry_settings.member_pricing_label}} Info</h3>
          <label class="md:w-full block text-gray-700 font-bold" >
            <p class="text-xl font-light">Are you a {{event.entry_settings.member_pricing_label}}?</p>
            <input v-model="entryGroup.member_pricing" class="mr-2 leading-tight" type="checkbox" @change="updateEntryGroupMembership">
            <span class="text-sm">
              I am a {{event.entry_settings.member_pricing_label}}
            </span>
          </label>
          <p class="text-sm text-gray-700 mt-2 font-semibold">**This box must be checked in order to receive the member discount pricing</p>

        </div>
        <div v-for="(q, i) in event.entry_questions" :key="i" class="py-6">
          <div v-if="(isDisabled(q) && !isAdmin && !q.details.admin_only) || isArchived" class="p-4 md:p-6 bg-gray-300 rounded-md border border-gray-400">
            <label class="block text-xl text-gray-800 font-bold">
              {{q.details.label}}
              <span v-if="q.is_pricing"> ({{currencySymbol}}{{q.pricing_details.rate ? q.pricing_details.rate : '0'}})</span>
            </label>
            <p class="mb-1 text-base text-red-800 font-semibold">Deadline has passed. Due date was ({{formatDate(q.details.due_date)}})</p>
            <p class="block text-lg text-gray-800 mb-2">{{q.question}}</p>
            <div v-for="(e,j) in exhibitorList(q)" :key="j" class="mb-2" :class="{'space-y-3':q.details.exhibitor_question, 'ml-2': q.details.exhibitor_question}">
              <div class="text-lg mb-1 pt-2 border-t font-bold" v-if="q.details.exhibitor_question">{{e.first_name}} {{e.last_name}}</div>
              <template v-if="q.details.answer_type !=='dropdown'">
                <div v-for="(option,k) in optionList(q)" :key="k" class="pb-3 flex items-center justify-start" :class="{'ml-3': q.details.multi_answer}">
                    <div class="w-40" v-if="q.details.multi_answer">{{option.value}}:</div>
                    <p v-if="q.details.answer_type === 'number'">
                      {{ (entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]) ? entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`] : 0 }}
                    </p>
                    <p v-else-if="q.details.answer_type === 'checkbox'">
                      {{ (entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]) ? 'Yes' : 'No' }}
                    </p>
                    <p v-else-if="q.details.answer_type === 'text'">
                      {{ entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : 'Question Not Answered'}`] }}
                    </p>
                    <template v-else-if="q.details.answer_type === 'file'">
                      <template v-if="entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]">
                        <display-file-type-field :url="entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]"/>
                      </template>
                      <template v-else>
                        <p>No File Uploaded</p>
                      </template>
                    </template>
                </div>
              </template>
              <template v-else-if="q.details.answer_type==='dropdown'">
                <template v-if="entryGroup.entry_questions[`${q.entry_question_id}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]">
                  <p>{{ entryGroup.entry_questions[`${q.entry_question_id}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`] }}</p>
                </template>
                <p v-else>Not Answered</p>
              </template>
            </div>
            <p class="text-base text-gray-600 mb-2">
              {{q.details.details}}
            </p>
          </div>
          <div v-else-if="!(isAvailable(q)) && (!isAdmin && !q.details.admin_only)" class="p-2 bg-gray-300 rounded-md border border-gray-500">
            <label class="block text-xl text-gray-800 font-bold">
              {{q.details.label}}
              <span class="text-lg text-red-700 font-bold mt-1">*SOLD OUT*</span>
            </label>
            <!--<p class="text-base" v-if="q.details.limited_availability">({{ getAvailable(q) }} of {{ q.details.number_available }} Available)</p>-->
            <template v-if="entryGroup.date_entered">
              <p class="block text-lg text-gray-800 mb-2">{{q.question}}</p>
              <p class="font-medium" v-if="entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]">
                You have {{ entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`] }} reserved
              </p>
            </template>
            <p class="text-base text-gray-600 mb-2">
              {{q.details.details}}
            </p>
          </div>
          <template v-else>
            <div v-if="((q.details.admin_only && isAdmin) || !q.details.admin_only)" class="border-b border-gray-300 pb-3" :class="{'bg-gray-100': checkIfQuestionGroup(q), 'p-3': checkIfQuestionGroup(q), rounded: checkIfQuestionGroup(q), border: checkIfQuestionGroup(q)}">
              <label class="block text-xl text-gray-800 font-bold">
                {{q.details.label}}
                <span v-if="q.is_pricing"> ({{currencySymbol}}{{q.pricing_details.rate ? q.pricing_details.rate : '0'}})</span>
                <span v-if="q.details.required" class="font-extrabold text-base text-red-900 ml-2">*Required*</span>
              </label>
              <p class="text-sm font-semibold">Answers due by ({{formatDate(q.details.due_date)}})</p>
              <p class="text-base" v-if="q.details.limited_availability && !(typeof q.details.number_reserved === 'undefined')">({{ q.details.number_available - q.details.number_reserved }} of {{ q.details.number_available }} Available)</p>
              <p class="block text-lg text-gray-800 mt-1.5 mb-2">{{q.question}}</p>
              <div v-if="!exhibitorList(q).length">You haven't added any entries yet, add your entries to answer this question for each exhibitor in your group.</div>
              <div v-for="(e,j) in exhibitorList(q)" :key="j" class="" :class="{'space-y-3':q.details.exhibitor_question, 'ml-2': q.details.exhibitor_question}" >
                <div class="text-lg mb-1 pt-2 border-t font-bold" v-if="q.details.exhibitor_question">{{e.first_name}} {{e.last_name}}</div>
                <template v-if="q.details.answer_type !=='dropdown'">
                  <div v-for="(option,k) in optionList(q)" :key="k" class="pb-3 flex items-center justify-start" :class="{'ml-3': q.details.multi_answer}">
                    <div class="w-40" v-if="q.details.multi_answer">
                      <span v-if="option.disabled">DISABLED - </span>{{option.value}}:
                    </div>
                    <div v-if="q.details.answer_type==='number'" class="flex justify-start items-stretch">
                      <button :disabled="option.disabled" @click="decrementEntryQuestion(q, `${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`)" type="button" class="inline-flex items-center p-1 border border-gray-400 rounded-l shadow-sm text-black bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z" clip-rule="evenodd" />
                        </svg>
                      </button>
                      <input :disabled="option.disabled" class="text-center focus:outline-none w-20 rounded-none block sm:text-sm border-t border-b border-gray-400 focus-none" :ref="`eq-${q.entry_question_id}`" v-if="q.details.answer_type==='number'" @change="entryQuestionPreSave(q, `${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`)" type="number" v-model.number="entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]" />
                      <button :disabled="option.disabled" @click="incrementEntryQuestion(q, `${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`)" type="button" class="inline-flex items-center p-1 border border-gray-400 rounded-r shadow-sm text-black bg-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <!-- Heroicon name: solid/plus-sm -->
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                        </svg>
                      </button>
                    </div>
                    <!--<input :ref="`eq-${q.entry_question_id}`" v-if="q.details.answer_type==='number'" min="0" @change="entryQuestionPreSave" type="number" v-model.number="entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]" class="text-input focus:outline-none focus:shadow-outline"/>-->
                    <input :disabled="option.disabled" v-else-if="q.details.answer_type==='checkbox'" @change="entryQuestionPreSave(q, `${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`)" type="checkbox" v-model="entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]" class="mr-2 leading-tight">
                    <input :disabled="option.disabled" v-else-if="q.details.answer_type==='text'" @change="entryQuestionPreSave(q)" type="text" v-model.trim="entryGroup.entry_questions[`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]" class="text-input focus:outline-none focus:shadow-outline">
                    <FilePondUploadWrapper @change="entryQuestionPreSave(q)" v-else-if="q.details.answer_type === 'file'" :dataObject="entryGroup.entry_questions" :field="`${q.entry_question_id}${q.details.multi_answer ? `:${option.id}` : ''}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`"/>
                    <span v-if="q.details.multi_answer && q.is_pricing" class="ml-2">({{currencySymbol}}{{option.pricing_details.rate ? option.pricing_details.rate : '0'}})</span>
                  </div>
                </template>
                <div v-else-if="q.details.answer_type==='dropdown'">
                  <div class="relative">
                    <select v-model="entryGroup.entry_questions[`${q.entry_question_id}${q.details.exhibitor_question ? `:${e.exhibitor_id}` : ''}`]" @change="entryQuestionPreSave(q)" class="block appearance-none w-full bg-gray-300 border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                      <option :value="null" selected disabled>
                        Please select an answer
                      </option>
                      <template v-if="q.details.dropdown_options_new">
                        <option v-for="(v, o) in q.details.dropdown_options_new.filter(option => !option.disabled)" :key="o" :value="v.value">
                          {{v.value}}
                          <template v-if="q.is_pricing">
                            <span>
                               - {{currencySymbol}}{{v.pricing_details.rate}}
                              <span v-if="event.entry_settings.has_member_pricing"> (members {{currencySymbol}}{{v.pricing_details.member_rate}})</span>
                            </span>
                          </template>
                        </option>
                      </template>
                      <template v-else>
                        <option  v-for="v in q.details.dropdown_options.split(',')"  :key="v" :value="v">
                          {{v}}
                        </option>
                      </template>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="q.details.limited_availability && !entryGroup.date_entered && entryGroup.entry_questions[`${q.entry_question_id}`]" class="text-blue-900 bg-blue-100 p-4 border border-blue-200 rounded-md">
                <p class="font-semibold">Spaces are not guaranteed until checkout is complete. Submit your entries to complete this reservation/purchase.</p>
              </div>
              <!--<div v-if="entryGroup.entry_questions[`${q.entry_question_id}_timestamp`] && !entryGroup.date_entered && entryGroup.entry_questions[`${q.entry_question_id}`]" class="bg-gray-200 p-3 border rounded-md">
                <count-down-timer-vue :ref="`eq-${q.entry_question_id}-timer`" :startTime="entryGroup.entry_questions[`${q.entry_question_id}_timestamp`]" :duration="reservationTime">
                  <div slot="before-time-up">
                    <p class="text-sm">This option will be reserved for you for {{reservationTime / 60}} minutes. If you do not complete your entry within this time, another exhibitor may have the option to purchase.</p>
                    <button class="mt-2 btn-sm btn-blue" @click="entryQuestionPreSave(q, q.entry_question_id)">Extend My Time</button>
                    <p class="text-sm font-gray-400">Need more time? Click the button above to extend the time your reservation will be held.</p>
                  </div>
                  <div slot="after-time-up">
                    <p class="text-lg">Your time is up</p>
                    <p class="text-sm ">This reservation is no longer guaranteed, complete your entries now to secure your reservation. </p>
                    <button class="mt-2 btn-sm btn-blue" @click="entryQuestionPreSave(q, q.entry_question_id)">Extend My Time</button>
                    <p class="text-sm font-gray-400">Need more time? Click the button above to extend the time your reservation will be held.</p>
                  </div>
                </count-down-timer-vue>
              </div>-->
              <p class="text-base text-gray-600 mb-2">
                {{q.details.details}}
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {parse} from 'date-fns'
import FilePondUploadWrapper from '@/components/FilePondUploadWrapper.vue'
// import CountDownTimerVue from './CountDownTimer.vue'

export default {
  components: {
    FilePondUploadWrapper
    // CountDownTimerVue
  },
  props: {
    // event: Object,
    entryGroup: Object,
    preview: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      reservationTime: 300,
      entry_questions: {},
      timeLapsed: false,
      savedEQData: {},
      loaded: false
    }
  },
  methods: {
    incrementEntryQuestion (q, entryQuestionString) {
      let current = this.entryGroup.entry_questions[entryQuestionString]
      let n = 1
      if (current) {
        n = current + 1
      }
      this.$set(this.entryGroup.entry_questions, entryQuestionString, n)
      this.entryQuestionPreSave(q, entryQuestionString)
    },
    decrementEntryQuestion (q, entryQuestionString) {
      let current = this.entryGroup.entry_questions[entryQuestionString]
      let n = 0
      if (current) {
        if (current > 0) {
          n = current - 1
        }
      }
      this.$set(this.entryGroup.entry_questions, entryQuestionString, n)
      this.entryQuestionPreSave(q, entryQuestionString)
    },
    entryQuestionPreSave (q, entryQuestionString) {
      if (this.preview) {
        return
      }

      if (q.details.limited_availability) {
        this.checkEntryQuestionAvailability(q)
          .then((reserved) => {
            let available = q.details.number_available - reserved
            if (this.entryGroup.date_entered) {
              let diff = this.entryGroup.entry_questions[entryQuestionString] - this.savedEQData[entryQuestionString]

              if (!available && diff > 0) {
                this.notie.alert({
                  type: 3,
                  text: `${q.details.label} - Unfortunately there aren't ${this.entryGroup.entry_questions[entryQuestionString]} available. Please select other option.`
                })
                this.$set(this.entryGroup.entry_questions, entryQuestionString, this.savedEQData[entryQuestionString])
                return
              }
              this.saveEntryQuestions(q)
            } else {
              if (available < this.entryGroup.entry_questions[entryQuestionString]) {
                let message = `<p class="text-xl md:text-3xl font-bold">The number of ${q.details.label} you requested are not available</p>We were unable to update your selection, please select another option or amount.`
                if (available > 0) {
                  message += `<p class="text-lg md:text-xl font-semibold">(There ${available > 1 ? 'are' : 'is'} only ${available} available)</p>`
                } else {
                  message += `<p class="text-lg md:text-xl font-semibold">(There are no more available)</p>`
                }
                this.notie.alert({
                  type: 3,
                  text: message,
                  time: 4
                })
                this.$set(this.entryGroup.entry_questions, entryQuestionString, this.savedEQData[entryQuestionString])
                return
              }
              this.saveEntryQuestions(q)
            }
          })
      } else {
        this.saveEntryQuestions(q)
      }
    },
    async saveEntryQuestions (q) {
      if (this.preview) {
        return
      }

      this.$store.dispatch('saveEntryQuestions', this.entryGroup)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: 'Entry Questions Updated'
          })
          this.$emit('update')
          this.savedEQData = JSON.parse(JSON.stringify(this.entryGroup.entry_questions))
          this.checkEntryQuestionAvailability(q)
        })
        .catch(() => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `Error saving entry questions, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },

    isDisabled (q) {
      let now = new Date()
      let dateString = `${now.getFullYear()}-${('0' + (now.getMonth() + 1)).slice(-2)}-${('0' + now.getDate()).slice(-2)}`

      if (q.details.due_date) {
        if (parse(q.details.due_date) >= new Date(dateString)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    isAvailable (q) {
      if (q.details.limited_availability) {
        /* if (!q.details.number_available) {
          await this.checkEntryQuestionAvailability(q)
        } */
        if (this.entryGroup.date_entered) {
          return true
        }
        if (q.details.number_reserved) {
          if (q.details.number_available - q.details.number_reserved > 0) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },
    formatDate (d) {
      return this.Localized.formatDate(d, this.event.location_details.country)
    },
    checkIfQuestionGroup (q) {
      if (q.details.exhibitor_question) {
        return true
      } else if (q.details.answer_type !== 'dropdown' && q.details.multi_answer === true) {
        return true
      } else {
        return false
      }
    },
    exhibitorList (q) {
      let list = []
      if (q.details.exhibitor_question) {
        if (!this.preview) {
          return this.entryGroup.exhibitors
          /* this.entryGroup.exhibitors.forEach(e => {
            list.push
          }) */
        } else {
          return [
            {
              exhibitor_id: 123,
              exhibitor_number: '001',
              first_name: 'John',
              last_name: 'Doe'
            },
            {
              exhibitor_id: 456,
              exhibitor_number: '002',
              first_name: 'Jane',
              last_name: 'Doe'
            }
          ]
        }
      } else {
        list = [1]
      }
      return list
    },
    optionList (q) {
      let list = [{
        value: 'SINGLE_ANSWER'
      }]
      if (q.details.multi_answer) {
        return q.details.answer_options
      } else {
        return list
      }
    },
    updateEntryGroupMembership () {
      this.$store.dispatch('updateEntryGroup', {
        entry_group_id: this.entryGroup.entry_group_id,
        member_pricing: this.entryGroup.member_pricing
      })
    },
    sortEntryQuestions () {
      this.event.entry_questions.sort((a, b) => {
        if (this.isDisabled(a) && !this.isDisabled(b)) {
          return 1
        } else if (!this.isDisabled(a) && this.isDisabled(b)) {
          return -1
        } else {
          return 0
        }
      })
    },
    checkEntryQuestionAvailability (q) {
      if (q.details.limited_availability) {
        if (!this.isAdmin) {
          return this.$store.dispatch('checkEventEntryQuestionAvailability', {entry_question_id: q.entry_question_id})
        } else {
          return this.$store.dispatch('checkEventEntryQuestionAvailability_admin', {entry_question_id: q.entry_question_id})
        }
      }
    },
    checkCurrentEntryQuetions () {
      this.event.entry_questions.forEach(q => {
        if (q.details.limited_availability) {
          let available = q.details.number_available - q.details.number_reserved
          if (available < this.entryGroup.entry_questions[q.entry_question_id]) {
            this.$set(this.entryGroup.entry_questions, q.entry_question_id, 0)
            this.entryQuestionPreSave(q, q.entry_question_id)
          }
        }
      })
    },
    getUpdatedEntryQuetions () {
      if (!this.isAdmin) {
        this.$store.dispatch('getEntryQuestions', this.entryGroup.entry_group_id)
          .then(response => {
            if (!this.entryGroup.date_entered) {
              this.checkCurrentEntryQuetions()
            }
            this.loaded = true
          })
      } else {
        this.$store.dispatch('getEntryQuestions_admin', this.entryGroup.entry_group_id)
          .then(response => {
            if (!this.entryGroup.date_entered) {
              this.checkCurrentEntryQuetions()
            }
            this.loaded = true
          })
      }
    }
  },
  computed: {
    event () {
      if (this.isAdmin) {
        return this.$store.state.admin.adminData.event
      } else {
        return this.$store.state.event.currentEvent
      }
    },
    isArchived () {
      return this.event.status === 'ARCHIVED'
    },
    currencySymbol () {
      return this.Localized.getCurrencyInfo(this.event.location_details.country).symbol
    }
  },
  mounted () {
    this.getUpdatedEntryQuetions()
    this.savedEQData = JSON.parse(JSON.stringify(this.entryGroup.entry_questions))
  }
}
</script>

<style scoped>
  /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
